import styled from "styled-components";

import {X} from "lucide-react";
import {themecolors} from "../utils/themecolors";
import {BareButton} from "./button";

const Close = styled.div``;
const Refresh = styled.div``;

const RefreshFeed = styled(({onClick, close, className, count}) =>
    <div className={className}>
        <Refresh>
            <BareButton onClick={onClick}>Refresh Feed</BareButton>
        </Refresh>
        <Close>
            <BareButton onClick={close}>
                <X size={18} />
            </BareButton>
        </Close>
    </div>
)`
  z-index: 1;
  position: absolute;
  width: 192px;
  margin-top: 32px;
  left: calc(50% - 89px);
  display: flex;
  ${Refresh} {
    box-shadow: 0 1px 3px rgb(0 0 0 / 16%);
    padding: 10px 12px 10px 16px;
    border-bottom-left-radius: 20px;
    border-top-left-radius: 20px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? theme.white_0 : 'rgb(36, 104, 189)'};
    display: flex;
  }
  ${Refresh} button {
    font-weight: 600;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? theme.blue_1 : theme.white_0};
  }
  ${Close} {
    box-shadow: 0 1px 3px rgb(0 0 0 / 16%);
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : '#2862ab'};
    border-bottom-right-radius: 20px;
    border-top-right-radius: 20px;
    width: 42px;
    display: flex;
    padding-left: 10px;
  }
  ${Close} button svg {
    color: ${({theme}) => theme.color.name === 'dark' ? theme.blue_1 : theme.white_0};
  }
  ${BareButton} {
    background-color: transparent;
  }
`;

export default RefreshFeed;
